var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value])
            && _vm.$hasRole(_vm.role.TRANSPORTER.value) && false)?_c('sidebar-item',{attrs:{"link":{
            name: this.$t('sidebar.dashboard'),
            icon: 'tim-icons icon-chart-pie-36',
            path: {name: 'transporter.dashboard'}
          }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value])
            && _vm.$hasRole(_vm.role.TRANSPORTER.value))?_c('sidebar-item',{attrs:{"material":true,"link":{
            name: this.$t('sidebar.users'),
            icon: 'group',
          }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.branches'),
            path: {name: 'transporter.subsidiary'},
            isRoute: false
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.users'),
            path: {name: 'transporter.user'},
            isRoute: false
          }}})],1):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value])
            && _vm.$hasRole(_vm.role.TRANSPORTER.value))?_c('sidebar-item',{attrs:{"link":{
            name: this.$t('sidebar.orders'),
            icon: 'tim-icons icon-delivery-fast',
          }}},[_c('sidebar-item',{attrs:{"link":{
            name: this.$t('sidebar.proposals'),
            path: {name: 'transporter.order_proposals'},
            isRoute: false,
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: this.$t('pages.order.title.order'),
            path:{ name: 'transporter.order'},
            isRoute: false,
          }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.list_documents'),
          path: {name: 'transporter.orders_documents'},
          isRoute: false,
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.import_cte'),
          path: {name: 'transporter.import_cte'},

          }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.not_imported_files'),
          path: {name: 'transporter.not_imported_files'},

          }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('placeholders.exports'),
          path: {name: 'transporter.orders_exports'},
          isRoute: false,
        }}})],1):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value])
            && _vm.$hasRole(_vm.role.TRANSPORTER.value))?_c('sidebar-item',{attrs:{"link":{
            name: this.$t('sidebar.quotes'),
            icon: 'tim-icons icon-chart-bar-32',
          }}},[_c('sidebar-item',{attrs:{"link":{
            name: this.$t('sidebar.quotes_received'),
            path: {name: 'transporter.order_quotes_transporter'},
            isRoute: false,
          }}})],1):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value])
            && _vm.$hasRole(_vm.role.TRANSPORTER.value))?_c('sidebar-item',{attrs:{"link":{
            name: this.$t('sidebar.drivers'),
            icon: 'tim-icons icon-single-02',
            path: {name: 'transporter.driver'},
          }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value, _vm.permission.INTEGRA_MANAGER__FINANCIER.value])
               && _vm.$hasRole(_vm.role.TRANSPORTER.value) && false)?_c('sidebar-item',{attrs:{"material":true,"link":{
              name: _vm.$t('sidebar.faturas'),
             icon: 'receipt',
             path: {name: 'transporter.bill'},
           }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"material":true,"link":{
              name: _vm.$t('sidebar.simulation'),
              icon: 'table',
            }}},[(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"material":true,"link":{
                name: _vm.$t('sidebar.simulation_tables'),
                path: {name: 'transporter.simulation_integra.tables'}

              }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"material":true,"link":{
                name: _vm.$t('sidebar.approve_table'),
                path: {name: 'transporter.simulation_integra.approve_table'}

              }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.approve_route_table'),
          path: {name: 'transporter.approve_route_table'},
      }}}):_vm._e()],1):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"material":true,"link":{
              name: _vm.$t('sidebar.settings'),
              icon: 'settings',
              path: {name: 'transporter.configuration'}

            }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.status_api'),
        icon: 'tim-icons icon-settings',
        path: {name: 'transporter.config_status_api'}
      }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }